var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSReloj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4287 0.142578C38.988 0.142578 50.4287 11.1595 50.4287 25.1426C50.4287 39.1256 39.4118 50.1426 25.4287 50.1426C11.8694 50.1426 0.428711 39.1256 0.428711 25.1426C0.428711 11.1595 11.4457 0.142578 25.4287 0.142578ZM21.1914 14.5494C21.1914 12.8544 22.4626 11.5833 23.7338 11.5833C25.4287 11.5833 26.6999 12.8544 26.6999 14.1256C26.6999 14.1256 26.6999 14.1256 26.6999 14.5494V25.5663H34.327C36.0219 25.5663 37.2931 26.8375 37.2931 28.1087C37.2931 29.8036 36.0219 31.0748 34.7507 31.0748C34.7507 31.0748 34.7508 31.0748 34.327 31.0748H23.7338C22.0389 31.0748 21.1914 29.8036 21.1914 28.5324V14.5494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSReloj);
export default __webpack_public_path__ + "static/media/SReloj.91ad2dc4.svg";
export { ForwardRef as ReactComponent };